import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAcreSquareLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M15.8963 5.74805H12.1633L4.78125 18.3081H8.51422L15.8963 5.74805Z",
				fill: "#222222"
			}), /* @__PURE__ */ _jsx("path", {
				fillRule: "evenodd",
				clipRule: "evenodd",
				d: "M14.2293 13.4758C14.2291 13.4688 14.2291 13.4618 14.2291 13.4548C14.2291 13.4478 14.2291 13.4409 14.2293 13.4339V13.4337C14.2406 12.5375 14.9706 11.8145 15.8694 11.8145C16.7684 11.8145 17.4984 12.5375 17.5097 13.4337H17.51V18.2908H14.2293V13.4758Z",
				fill: "#222222"
			})]
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 1,
			y: 1,
			width: 22,
			height: 22,
			stroke: "#222222",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 13.6875,
				height: 13.6875,
				fill: "white",
				transform: "translate(4.78125 5.25)"
			})
		}) })
	]
});
export default SvgAcreSquareLogo;
